module.exports = "https://cdn-skillquest.mathletics.com/app/188/assets/images/630822338b3b498594075c8450abb52b.svg";